import BasicContentVerticalTiles from './BasicContentVerticalTiles';

export { type BasicContentVerticalTilesProps } from './BasicContentVerticalTiles';
export default BasicContentVerticalTiles;
